import { Dropdown, Progress } from 'antd';
import cx from 'classnames';
import React from 'react';
import ADDRESS_VIEW from 'assets/img/addressView.png';
import ANALYTICS_VIEW from 'assets/img/analyticsView.png';
import ADDRESS_VIEW_DARK from 'assets/img/black/addressView.png';
import ANALYTICS_VIEW_DARK from 'assets/img/black/analyticsView.png';
import LINE_DARK from 'assets/img/black/lineIcon.png';
import LOAD_DARK from 'assets/img/black/load.svg';
import TILE_DARK from 'assets/img/black/tileIcon.png';
import LINE from 'assets/img/lineIcon.png';
import LOAD from 'assets/img/load.png';
import ARROW from 'assets/img/play_arrow.svg';
import ARROW_BLUE from 'assets/img/play_arrow_blue.svg';
import TILE from 'assets/img/tileIcon.png';
import { AddressView, AprroveCustomizeIcons, CustomIcon } from '../../../../common';
import {
  SpeedInfoBlock, AccessTypes, TechnologiesBlock, TopProviders, TypeBlock,
  FilterDropdown, ConfidenceBlock,
} from '../index';
import './style.scss';

export const ProjectInfo = ({
  isAddressView, toggleState, isTileView, chooseFilter, isDarkTheme,
  filter, isPublicView, openWhyPopup, toggleShowDetail,
}) => (
  <div className={cx('project_info', {
    project_info_public: isPublicView,
  })}
  >
    <div className="project_info_header">
      <h2>PRIMARY SOLUTION</h2>
      <div className="project_info_header_competion restyled-progress">
        <Progress percent={65} />
        <span className="project_info_header_competion_text"> completion</span>
      </div>
      <div className="project_info_header_toggleView" onClick={() => toggleState('isAddressView')}>
        <img
          src={isAddressView
            ? isDarkTheme
              ? ADDRESS_VIEW_DARK
              : ADDRESS_VIEW
            : isDarkTheme
              ? ANALYTICS_VIEW_DARK
              : ANALYTICS_VIEW}
          alt=""
          style={{ boxShadow: '0 0 5px 0 rgba(0, 0, 0, 0.11)', width: '80px', height: '40px' }}
        />
      </div>
    </div>
    <div className="project_toggleMode">
      <CustomIcon width="9px" height="9px" src={isDarkTheme ? ARROW_BLUE : ARROW} rotate={-90} />
      <p>View secondary solution</p>
    </div>
    <div className="project_info_row">
      <h2 className="project_info_subtitle">Technologies</h2>
    </div>
    <TechnologiesBlock openWhyPopup={openWhyPopup} isDarkTheme={isDarkTheme} />

    {isAddressView
      ? (
        <div className="project_info_address_view">
          <div className="project_info_address_view_row">
            <div className="project_info_address_view_header">
              <span>54</span>
              <p>Addresses</p>
            </div>
            <div className="project_info_address_view_nav">
              <img
                src={isTileView
                  ? isDarkTheme
                    ? TILE_DARK
                    : TILE
                  : isDarkTheme
                    ? LINE_DARK
                    : LINE}
                alt=""
                onClick={() => toggleState('isTileView')}
                style={{ boxShadow: '0 0 5px 0 rgba(0, 0, 0, 0.11)', width: '80px', height: '40px' }}
              />
              <Dropdown trigger={['click']} overlay={<FilterDropdown chooseFilter={chooseFilter} filter={filter} />}>
                <div className="project_info_address_view_nav_dropdown">
                  <span>Filter by</span><CustomIcon src={isDarkTheme ? ARROW_BLUE : ARROW} width="8px" height="10px" />
                </div>
              </Dropdown>
            </div>
          </div>
          <div className="project_icon_row" style={{ marginLeft: '16px' }}>
            <AprroveCustomizeIcons isOverride isCustomize />
          </div>
          <div
            className="project_info_address_view_layout"
            style={{
              flexFlow: isTileView ? 'row wrap' : 'column nowrap',
              justifyContent: isTileView ? 'space-between' : 'flex-start',
            }}
          >
            <AddressView
              isTileView={isTileView}
              toggleShowDetail={toggleShowDetail}
              isOverriden
              isCustomized
            />
            <AddressView isTileView={isTileView} toggleShowDetail={toggleShowDetail} isOverriden />
            <AddressView isTileView={isTileView} toggleShowDetail={toggleShowDetail} isCustomized />
            <AddressView isTileView={isTileView} toggleShowDetail={toggleShowDetail} />
            <div className="project_info_load">
              <CustomIcon src={isDarkTheme ? LOAD_DARK : LOAD} width="16px" height="16px" />Load More Addresses
            </div>
          </div>
        </div>
      )
      : (
        <React.Fragment>
          <div className="project_info_row">
            <TypeBlock />
            <ConfidenceBlock />
          </div>
          <div className="project_info_row">
            <h2 className="project_info_subtitle">Speed </h2>
          </div>
          <SpeedInfoBlock />
          <div className="project_info_row">
            <TopProviders isDarkTheme={isDarkTheme} />
            <AccessTypes isDarkTheme={isDarkTheme} />
          </div>
        </React.Fragment>
      )}
  </div>
);



// WEBPACK FOOTER //
// ./src/view/screens/Project/components/ProjectInfo/index.js